import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { SarlaftCallInfoProps } from './props';
import { useSarlaftCallInfo } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftCallInfo = (props: SarlaftCallInfoProps) => {
    const { formik, channels } = useSarlaftCallInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información de la llamada
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(channels)}
                    label="Canal"
                    name="channel"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.channel}
                    errors={formik.errors.channel}
                    value={formik.values.channel}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('channel', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
